import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageJson from '../package.json'

import { datadogRum } from '@datadog/browser-rum';

if (environment.production) {
    enableProdMode();
    // initializeDatadog();
}

function initializeDatadog() {
    datadogRum.init({
        applicationId: '85ff16f2-0e3a-468b-9b26-6ef6661c7ae5',
        clientToken: 'pub2a753295ef24fa1d0acff572a69f99eb',
        site: 'datadoghq.com',
        service: 'menu-ui',
        env: 'prod',
        // Specify a version number to identify the deployed version of your application in Datadog
        version: packageJson.version,
        sampleRate: 100,
        trackInteractions: true
    });
}
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
